import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-request-type-sidebar',
  templateUrl: './request-type-sidebar.component.html',
  styleUrls: ['./request-type-sidebar.component.scss'],
  standalone: false,
})
export class RequestTypeSidebarComponent {
  @Input() title: string;
  @Input() subTitle: string;
}
